import { Redirect, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'redux'
import config from '../../config.json'
import { PROGRAM } from '../../constants/state'
import toJS from '../../hoc/toJS'

const mapStateToProps = state => ({
    updates: state.getIn([PROGRAM, 'updates'])
})

const CheckRoute = ({component: Component, updates, goBackPath: goBackPath, altGoBackPath: altGoBackPath, updateRemote: updateRemote, ...rest}) => {
  
    return (
        <Route {...rest} render = {(props) => {
            if(updates.hasUpdates) {
                const pathname = props.location.pathname 
                const splitArray = pathname.slice(1).split('/')
                const updatesPathFirtsLevel = updates.lastUpdateIn[0]

                if(splitArray.length > 0 && updatesPathFirtsLevel !== splitArray[0])  {
                    if('movies' === updatesPathFirtsLevel) {
                        return <Redirect to={`${config.routes.movies.path}/save`} />
                    } else if('newsletter' === updatesPathFirtsLevel) {
                        return <Redirect to={`${config.routes.newsletter.path}/save`} />
                    }
                }
            }

            return <Component {...{
                ...(goBackPath && {goBackPath: goBackPath}),
                ...(altGoBackPath && {altGoBackPath: altGoBackPath}),
                ...(updateRemote && {updateRemote: true}),
                ...props
            }} />
        }}/>
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(CheckRoute)